import WelcomeImage from '@/assets/images/welcome.svg';
import { useAdminContext } from '@/contexts/AdminContext';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@common/index';
import { Cross2Icon } from '@radix-ui/react-icons';
import React from 'react';
import { createPortal } from 'react-dom';
import styles from './Welcome.module.scss';

interface WelcomeModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ForNextPulseModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose }) => {
    const { modal } = useAdminContext();
    
    // Don't show modal if it has been shown before or if not open
    if (!isOpen) return null;

    return createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.content}>
                    <div className={styles.leftSection}>
                        <div className={styles.welcomeHeader}>
                            <h2 className={styles.title}>Don’t miss tomorrow’s Pulse</h2>
                            <p className={styles.benefitsTitle}>
                                Upgrade your Bustly plan to receive a daily Pulse at 7:00 AM. Your first free Pulse remains available.
                            </p>
                        </div>
                        
                        <div className={styles.actions}>
                            <Button onClick={onClose} variant="outline">Maybe Later</Button>
                            <Button
                                onClick={() => {
                                    modal.openModal('pricing')
                                    onClose()
                                }}
                            >
                                Upgrade
                            </Button>
                        </div>
                    </div>
                    
                    <div className={styles.rightSection}>
                        <img src={WelcomeImage} alt="Welcome" />
                    </div>
                </div>
                <div className={styles.close}>
                    <Cross2Icon onClick={onClose} />
                </div>
            </div>
        </div>,
        document.body
    );
};

export const PaySuccessModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose }) => {
    // Don't show modal if it has been shown before or if not open
    if (!isOpen) return null;
    const {userBilling: { userPlan }} = useAuth();
    return createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.content}>
                    <div className={styles.leftSection}>
                        <div className={styles.welcomeHeader}>
                            <h2 className={styles.title}>{`You're in! 🎉`}</h2>
                            <p className={styles.benefitsTitle}>
                                You can start building dashboards, exploring insights, and receive
                                Pulse updates every morning at 7:00 AM (local time).
                            </p>
                        </div>

                        <div className={styles.actions}>
                            <Button onClick={onClose}>
                                Got it
                            </Button>
                            <div style={{flex: 1}}></div>
                        </div>
                    </div>

                    <div className={styles.rightSection}>
                        <img src={WelcomeImage} alt="Welcome" />
                    </div>
                </div>
                <div className={styles.close}>
                    <Cross2Icon onClick={onClose} />
                </div>
            </div>
        </div>,
        document.body
    );
};
